import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AdminService } from 'src/app/business-service/admin/admin.service';
import { ClientAdminService } from 'src/app/business-service/client-admin/client-admin.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { jwtDecode } from 'jwt-decode';



@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  loginForm!: FormGroup;
  showSpinner: boolean = false;
  expired: boolean = false;
  errorMessage: any;
  passwordChangeForm!: FormGroup;
  userDetails: any; // Holds user details fetched from the service
  userId: any; // Holds the user ID fetched from the route
  cId: any;
  userName: any;
  orgName: any;

  constructor(
    private _fb: FormBuilder,
    private _adminService: AdminService,
    private _responseNotification: ResponseNotificationService,
    private _globalService: GlobalService,
    private _userService: ClientAdminService, // Inject the ClientAdminService
    private route: ActivatedRoute,
    private _router: Router,

  ) { }

  ngOnInit() {
    this.passwordChangeForm = this._fb.group({
      email: ['', [Validators.required, Validators.email]],
      newPassword: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/)
        ],
      ],
      confirmNewPassword: ['', [Validators.required]],
    },
      {
        validator: this.passwordMatchValidator,
      });
    this.fetchUserDetails();

  }

  passwordMatchValidator(group: FormGroup) {
    const password = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmNewPassword')?.value;

    if (password !== confirmPassword) {
      group.get('confirmNewPassword')?.setErrors({ passwordMismatch: true });
    } else {
      group.get('confirmNewPassword')?.setErrors(null);
    }
    return null;
  }


  onSubmit() {

    if (this.passwordChangeForm.invalid) {
      console.log("Form is invalid. Listing errors:");

      Object.keys(this.passwordChangeForm.controls).forEach((field) => {
        const control = this.passwordChangeForm.get(field);
        if (control?.errors) {
          console.log(`Errors for ${field}:`, control.errors);
        }
      });
    }


    if (this.passwordChangeForm.valid) {
      this.showSpinner = true;
      const { newPassword } = this.passwordChangeForm.value;
      this._adminService.changePasswordFromEmail(this.userId, this.cId, 'User', newPassword).subscribe(
        (response) => {
          this.showSpinner = false;
          this._responseNotification.showMessage("Password changed successfully");
          this._router.navigate(["/login"]);

        },
        (error) => {
          this.showSpinner = false;
          console.error('Error changing password:', error);
          this._responseNotification.showMessage(error.error, true);

        }
      );
    } else {
      this.showSpinner = false;
      this._globalService.customAlert("Please enter a secure password with at least 8 characters, including an uppercase letter, a lowercase letter, a number, and a special character. Make sure both password fields match exactly to proceed.", "Invalid Form");
    }
  }

  getPasswordErrorMessage() {
    const control = this.passwordChangeForm.get('newPassword');
    if (control?.hasError('required') && control.touched) return 'Password required.';
    if (control?.hasError('minlength') && control.touched) return 'Password must be at least 8 characters long.';
    if (control?.hasError('pattern') && control.touched) return 'Password must contain an uppercase letter, lowercase letter, digit, and special character.';
    return null;
  }


  fetchUserDetails() {

    this.route.queryParams.subscribe(params => {
      const token = params['token'];

      if (token) {
        try {
          const decodedToken: any = jwtDecode(token);
          this.userId = decodedToken.Id; // Extract UserID if needed

          // Extract Email and set it in the form
          const email = decodedToken.Email;
          this.cId = decodedToken.cId;
          this.userName = decodedToken.UserName;
          this.orgName = decodedToken.CName;
          this.passwordChangeForm.patchValue({ email: email });
        } catch (error) {
          console.error("Invalid token", error);
        }
      }
    });
  }
  // this.userId = "test_t1";

  hasUpperCase(): boolean {
    const value = this.passwordChangeForm.get('newPassword')?.value || '';
    return /[A-Z]/.test(value);
  }
  hasLowerCase(): boolean {
    const value = this.passwordChangeForm.get('newPassword')?.value || '';
    return /[a-z]/.test(value);
  }
  hasNumber(): boolean {
    const value = this.passwordChangeForm.get('newPassword')?.value || '';
    return /\d/.test(value);
  }
  hasSpecialChar(): boolean {
    const value = this.passwordChangeForm.get('newPassword')?.value || '';
    return /[\W_]/.test(value);
  }
  hasMinLength(): boolean {
    const value = this.passwordChangeForm.get('newPassword')?.value || '';
    return value.length >= 8;
  }
  isEmpty(): boolean {
    const value = this.passwordChangeForm.get('newPassword')?.value || '';
    return value.length === 0;
  }

}






